
import React, { Component } from 'react'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconMenu from 'material-ui/IconMenu'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router'
import Colors from 'material-ui/styles/colors'
import {List, ListItem} from 'material-ui/List'

import Avatar from 'material-ui/Avatar'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'

import StarsRating from 'components/StarsRating'
import ShowDistance from 'components/ShowDistance'


export default (o) => {
	return(
	(!o.agent)? <div></div>
	:<Link
		style={{
			textDecoration: 'none'
		}}
		key={o.agent._id || 'All'}
		onClick={(evt) => {
			if(evt.target.className == 'assign-block'
				|| evt.target.parentNode.className == 'assign-block'
				|| evt.target.parentNode.parentNode.className == 'assign-block'
				|| evt.target.className == 'assign-element'
				|| evt.target.parentNode.className == 'assign-element'
				|| evt.target.parentNode.parentNode.className == 'assign-element'
			){
				evt.preventDefault()
				evt.stopPropagation()
				return false
			}
		}}
		to={(!o.agent.isYelp)? (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?`/manager/agents/${o.id}`: `/manager/agents/${o.id}`: ''}
		className="ent-card agent-card"
	>
		<ListItem
			key={`agents-${o.id}`}
			style={{
				height: "80px"
			  , backgroundColor: (o.lastInteracted == o.id)? "#E8E8E8": "#FFF"
			  , overflow: 'hidden'
			  , paddingLeft:  (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0" :"0px"
			  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "" : "0"
			  , border: "1px solid #e1e3e2"
			  , margin: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "-2px 10px 0 10px" : "0 0 0 10px"
			  , width: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "100%" :"auto"
			}}
			key={o.agent._id}
			leftAvatar={
				<div
					className="avatar"
					style={{
						marginTop: (typeof global.md.phone() == 'string')? "5px" : "-1px"
					  , marginLeft: (typeof global.md.phone() == 'string')? "auto" : "16px"
					  , width: "45px"
					  , height: "45px"
					  , backgroundColor: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
							  (o.agent.tasksActive && o.agent.tasksActive.length)?
								  "#d0d0d0"
								  :(!o.agent.retired)?
										"#3cd2ae"
										  : "#d0d0d0"
							: "transparent"
					}}
				>
					<p
						className="counter-text"
						style={{
							width: "22px"
						  , height: "22px"
						  , lineHeight: "22px"
						  , borderRadius: "7px"
						  , textAlign: "center"
						  , marginTop: "13px"
						  , backgroundColor: (o.agent.tasksActive && o.agent.tasksActive.length)?
										"#000"
										:(!o.agent.retired)?
											  "#3cd2ae"
											  :"#3cd2ae"
						  , color: "#FFF"
						}}
					>
						<span
							style={{
								fontSize: "12px"
	  						  , lineHeight: "9px"
							  , verticalAlign: "middle"
							}}
						>
							{(o.agent.tasksDone)?o.agent.tasksDone.length: 0}
						</span>
					</p>
				</div>
			}
			primaryText={
				<div>
					<p
						className="main-text"
						style={{
							position: "relative"
						  , maxWidth: "30%"
						  , fontSize: "14px"
						  , fontWeight: "bold"
						  , marginTop: "2px"
						  , marginLeft: "6px"
						  , marginBottom: "0px"
						  , textOverflow: "ellipsis"
						  , whiteSpace: "nowrap"
						  , overflow: "hidden"
						}}
					>
						{`${o.agent.firstName}`}
					</p>
					{/*<div
						className="secondary-text"
						style={{
							float: "right"
						  , marginRight: "40%"
						  , width: "34.7%"
						  , marginTop: "-1px !important"
						}}
					>
						{(o.agent.categories && o.agent.categories.length)?
							<p style={{fontSize: "14px", position: "relative", paddingLeft: "0px", margin: '0', color: "#000000", top:"-1px"}}>
								{o.agent.categories.map((category, indx, arr) =>
									(indx == 0 || o.agent.id)?
										category
										: (arr && indx == arr.length -1)?
											` and ${category}`
											: `, ${category}`
								)}
							</p>
							: <p style={{fontSize: "12px", clear: "left", position: "relative", paddingLeft: "0px", margin: '0', color: "#000000"}}>No categories</p>
						}
					</div>*/}
					{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
						""
						:
						<div
							className="assign-block"
							style={{
								position: "absolute"
							  , right: "30px"
							  , fontSize: "15px"
							  , lineHeight: "76px"
							  , top: "0"
							}}
						>

							<div
								style={{
									textDecoration: 'none'
								  , cursor: "pointer"
								  , display: (o.rightStackOpened && !o.refTask)? 'none': 'block'
								}}
								onClick={(evt) => {
									if(o.refTask){
										o.docUpd({_id: o.refTask, agentID: o.agent._id})
										o.docUpd({_id: o.agent._id, tasks: [...o.agent.tasks, o.refTask]})
										this.props.go(`/manager/tasks/${o.refTask}`)
										evt.preventDefault()
										return false
									}else{
										o.history.push({
											pathname: `/manager/tasks`,
											state: { refAgent: o.agent._id }
										})
									}
								}}
								className="assign-element"
							>
									<svg
										width="22px"
										height="22px"
										viewBox="0 0 24 24"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xmlnsXlink="http://www.w3.org/1999/xlink"
										style={{
											verticalAlign: "middle"
										  , stroke: "#3cd2ae"
										}}
										className="assign-element"
									>
									    <defs></defs>
									    <g id="Page-1" stroke="none" strokeWdth="1" fill="none" fillRule="evenodd">
									        <g id="Group-2" transform="translate(1.000000, 1.000000)" stroke="#3cd2ae" strokeWidth="2">
									            <path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
									            <path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
									            <circle id="Oval-1" cx="11" cy="11" r="11"></circle>
									        </g>
									    </g>
									</svg>
									<span
										style={{
											verticalAlign: "middle"
										  , color: "#3cd2ae"
										  , marginLeft: "10px"
										}}
										className="assign-element hideable"
									>
										{(o.refTask)? "ASSIGN THIS AGENT TO TASK" : "ASSIGN NEW TASK"}
									</span>
								</div>
						</div>
					}
				</div>

			}
			secondaryText={(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
				""
				:
				<div
					style={{
						marginTop: "10px"
					}}
				>
					<StarsRating
						className="rating"
						style={{
							display: "inline-block"
						  , verticalAlign: "middle"
						  , marginLeft: "6px"
						}}
						size = "15px"
						color = "Colors.grey500"
						key={`${o.agent._id}-${o.agent.rating}`}
						value = {(o.agent.rating)?o.agent.rating:"0"}
					/>
					{(o.property._id && o.property._id != 'All')?
						<ShowDistance
							style={{
								display: "inline-block"
							  , color: "#3cd2ae"
							  , fontSize: "12px"
							  , verticalAlign: "middle"
							  , marginLeft: "10px"
							  , marginTop: "-7px"
							}}
							first={
								(o.agent.cors && o.agent.cors.lat)?
									o.agent.cors
									: o.agent.address.replace('\n', '+')
							}
							key={o.property._id}
							loaderSize={0.25}
							second={
								(
									o.property.cors
									&& o.property.cors.lat
								)?
									o.property.cors
									:
										(o.property)?
											o.property.address.replace('\n', '+')
											: "LOADING"
							}
							callBack={(newCors, type) =>{
								(type == "first")?
									o.docUpd({
										_id: o.agent._id
									  , cors: newCors
									})
									:
									o.docUpd({
										_id: o.property._id
									  , cors: newCors
									})}
							}
						/>
						:""
					}
				</div>
			}
			secondaryTextLines={2}
			className="list-hover"
		>
		{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
			<div
				className="distance"
				style={{float: "right", color: "#000", fontSize: "14px"}}>
				<br/>
				{(o.property._id && o.property._id != 'All')?
					<ShowDistance
						style={{
							float: 'right'
						  , marginTop: "7px"
						  , marginLeft: "10px"
						}}
						first={
							(o.agent.cors && o.agent.cors.lat)?
								o.agent.cors
								: o.agent.address.replace('\n', '+')
						}
						key={o.property._id}
						loaderSize={0.25}
						second={
							(
								o.property.cors
								&& o.property.cors.lat
							)?
								o.property.cors
								:
									(o.property)?
										o.property.address.replace('\n', '+')
										: "LOADING"
						}
						callBack={(newCors, type) =>{
							(type == "first")?
								o.docUpd({
									_id: o.agent._id
								  , cors: newCors
								})
								:
								o.docUpd({
									_id: o.property._id
								  , cors: newCors
								})}
						}
					/>
					:""
				}
				<StarsRating
					className="rating"
					style={{float: "right", marginTop:"7px"}}
					size = {(typeof global.md.phone() == 'string')? "13pt" : "12px"}
					color = "Colors.grey500"
					key={`${o.agent._id}-${o.agent.rating}`}
					value = {(o.agent.rating)?o.agent.rating:"0"}
				/>
			</div>
		: "" }
		</ListItem>
		{(typeof global.md.phone() == 'string')? <Divider style={{padding: "1"}} />: ""}
	</Link>
)}



// WEBPACK FOOTER //
// ./src/routes/manager/agents/AgentCard.js